import React from 'react';
import { Button } from "@/components/ui/button";
import { ArrowRight, CreditCard, Store } from "lucide-react";
import { motion, AnimatePresence } from 'framer-motion';
import { cn } from "@/lib/utils";

const PricingButtonLanding = ({ planConfig }) => {
    const getPlanColor = (planKey) => {
        switch (planKey) {
            case "Basic":
                return "bg-blue-500 hover:bg-blue-600 border-blue-500";
            case "Pro":
                return "bg-amber-500 hover:bg-amber-600 border-amber-500";
            case "Premium":
                return "bg-purple-500 hover:bg-purple-600 border-purple-500";
            default:
                return "bg-blue-500 hover:bg-blue-600 border-blue-500";
        }
    };

    return (
        <div className="space-y-2.5">
            {/* Tarjeta Option */}
            <Button
                className={cn(
                    "w-full h-12 bg-white border-2 group relative overflow-hidden shadow-sm hover:shadow-md transition-all duration-200",
                    getPlanColor(planConfig.name).replace('bg-', 'border-').replace('hover:bg-', 'hover:bg-').replace('500', '500').replace('600', '50')
                )}
            >
                <div className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/5 to-white/0 opacity-0 group-hover:opacity-100 duration-300" />
                <div className="flex items-center justify-between w-full px-4">
                    <div className="flex items-center gap-2.5 text-gray-700">
                        <CreditCard className="h-4 w-4 flex-shrink-0" />
                        <span className="font-medium">Tarjeta - Stripe</span>
                    </div>
                    <span className="text-xs bg-green-50 text-green-700 px-2.5 py-1 rounded-full font-medium">
                        Recomendado
                    </span>
                </div>
            </Button>
            
            {/* OXXO Option */}
            <Button
                className="w-full h-12 bg-white border-2 border-gray-200 hover:border-gray-300 hover:bg-gray-50 text-gray-700 group relative overflow-hidden shadow-sm hover:shadow-md transition-all duration-200"
            >
                <div className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/5 to-white/0 opacity-0 group-hover:opacity-100 duration-300" />
                <div className="flex items-center justify-between w-full px-4">
                    <div className="flex items-center gap-2.5">
                        <Store className="h-4 w-4 flex-shrink-0" />
                        <span className="font-medium">OXXO - Tiendas</span>
                    </div>
                    <span className="text-xs bg-amber-50 text-amber-700 px-2.5 py-1 rounded-full font-medium">
                        Pago en Efectivo
                    </span>
                </div>
            </Button>

            <p className="text-xs text-center text-gray-500">
                Pago seguro · Cancela cuando quieras
            </p>
        </div>
    );
};

export default PricingButtonLanding;